export const ar = {
  dashboard: 'لوحة التحكم',
  category: 'الفئة',
  service: 'الخدمة',
  department: 'القسم',
  tickets: 'التذاكر',
  complain: 'فئات المشاكل',
  provider: 'مزود',
  activity_logs: 'سجلات النشاط',
  main: 'الرئيسي',
  add: 'إضافة',
  update: 'تحديث',
  delete: 'حذف',
  edit: 'تعديل',
  view: 'عرض',
  activity_logs_subtitle: 'مراقبة إجراءات النظام للتدقيق والتصحيح',
  name: 'الاسم',
  id: 'المعرف',
  actions: 'الإجراءات',
  search: 'بحث',
  search_tickets: 'بحث عن التذاكر...',
  cancel: 'إلغاء',
  processing: 'جاري المعالجة...',
  loading: 'جاري التحميل...',
  status: 'الحالة',
  active: 'نشط',
  inactive: 'غير نشط',
  no_data: 'لا توجد بيانات متاحة',
  merchant_panel: 'دعم العملاء',
  user_management: 'إدارة المستخدمين',
  customers: 'العملاء',
  contact_us: 'تواصل معنا',
  contact_us_list: 'قائمة تواصل معنا',
  return: 'أوامر الإرجاع',
  order_return: 'أوامر الإرجاع',
  ecom_orders: 'أوامر الإرجاع',
  return_request: 'طلب إرجاع',
  return_request_details: 'تفاصيل طلب إرجاع',
  filter_start_date: 'تاريخ البداية',
  filter_end_date: 'تاريخ النهاية',
  apply: 'تطبيق',
  reset: 'إعادة تعيين',
  show: 'عرض',
  entries: 'سجلات',
  return_number: 'رقم الإرجاع',
  order_number: 'رقم الطلب',
  customer_name: 'اسم العميل',
  return_request_date: 'تاريخ طلب الإرجاع',
  return_request_time: 'وقت طلب الإرجاع',
  items_count: 'عدد العناصر',
  return_amount: 'مبلغ الإرجاع',
  refund_amount: 'مبلغ الاسترداد',
  return_status: 'حالة الإرجاع',
  mobile: 'الجوال',
  customer_address: 'عنوان العميل',
  billed_to: 'فاتورة إلى',
  return_reason: 'سبب الإرجاع',
  category: 'الفئة',
  return_items: 'عناصر الإرجاع',
  product: 'المنتج',
  price: 'السعر',
  return_qty: 'كمية الإرجاع',
  total_return_amount: 'إجمالي مبلغ الإرجاع',
  return_shipping_fee: 'رسوم شحن الإرجاع',
  total_refund_amount: 'إجمالي مبلغ الاسترداد',
  status_history: 'سجل الحالة',
  customer_details: 'تفاصيل العميل',
  original_order_info: 'معلومات الطلب الأصلي',
  order_date: 'تاريخ الطلب',
  order_total_amount: 'إجمالي مبلغ الطلب',
  warehouse_details: 'تفاصيل المستودع',
  code: 'الرمز',
  address: 'العنوان',
  city: 'المدينة',
  settings: 'الإعدادات',
  profile: 'الملف الشخصي',
  select_service: 'اختر الخدمة',
  select_provider: 'اختر المزود',
  select_department: 'اختر القسم',
  select_category: 'اختر الفئة',
  search_service: 'ابحث عن الخدمة',
  search_provider: 'ابحث عن المزود',
  search_department: 'ابحث عن القسم',
  search_category: 'ابحث عن الفئة',
  service_list: 'قائمة الخدمات',
  department_list: 'قائمة الأقسام',
  provider_list: 'قائمة المزودين',
  category_list: 'قائمة الفئات',
  ticket_list: 'قائمة التذاكر',
  complain_list: 'قائمة فئات المشاكل',
  role: 'الدور',
  select: 'اختر',
  generate_ticket: 'إنشاء تذكرة',
  category_name: 'اسم الفئة',
  service_name: 'اسم الخدمة',
  department_name: 'اسم القسم',
  department_name_ar: 'اسم القسم',
  provider_name: 'اسم المزود',
  external_ticket_id: 'رقم التذكرة الخارجية',
  enter_category_name: 'أدخل اسم الفئة',
  enter_service_name: 'أدخل اسم الخدمة',
  enter_department_name: 'أدخل اسم القسم',
  enter_provider_name: 'أدخل اسم المزود',
  issue_en: 'القضية (الإنجليزية)',
  issue_ar: 'القضية (العربية)',
  enter_issue: 'أدخل القضية',
  enter_phone_number: 'أدخل رقم الهاتف',
  country_code: 'رمز الدولة',
  phone_number: 'رقم الهاتف',
  select_country_code: 'اختر رمز الدولة',
  enter_your_phone_number: 'أدخل رقم هاتفك',
  phone_number_required: 'رقم الهاتف مطلوب',
  phone_number_digits_only: 'يجب أن يحتوي رقم الهاتف على أرقام فقط',
  phone_number_too_short: 'رقم الهاتف قصير جداً',
  service_provider: 'مزود الخدمة',
  required: 'مطلوب',
  all_services: 'جميع الخدمات',
  all_categories: 'جميع الفئات',
  filter_by_category: 'تصفية حسب الفئة',
  all_providers: 'جميع المزودين',
  all_departments: 'جميع الأقسام',
  select_service_first: 'اختر الخدمة أولاً',
  no_providers: 'لا توجد مزودين متاحين',
  admin_dashboard: 'لوحة تحكم المسؤول',
  refresh: 'تحديث',
  refreshing: 'جاري التحديث...',
  refresh_dashboard: 'تحديث لوحة التحكم',
  open_tickets: 'التذاكر المفتوحة',
  resolved_tickets: 'التذاكر التي تم حلها',
  rejected_tickets: 'التذاكر المرفوضة',
  service_wise_summary: 'ملخص حسب الخدمة',
  loading_service_summary: 'جاري تحميل ملخص الخدمة...',
  total_count: 'إجمالي التذاكر:',
  open: 'مفتوح',
  open_label: 'مفتوح:',
  pending: 'قيد الانتظار',
  in_progress: 'قيد التنفيذ',
  in_progress_label: 'قيد التنفيذ:',
  rejected: 'مرفوض',
  rejected_label: 'مرفوض:',
  resolved: 'تم الحل',
  resolved_label: 'تم الحل:',
  resolved_at: 'تاريخ الحل',
  no_service_data_available: 'لا توجد بيانات خدمة متاحة',
  tickets_by_service: 'التذاكر حسب الخدمة',
  day: 'يوم',
  week: 'أسبوع',
  month: 'شهر',
  ticket_distribution_by_status: 'توزيع التذاكر حسب الحالة',
  tickets_status_by_service: 'حالة التذاكر حسب الخدمة',
  escalated: 'تم التصعيد',
  showing: 'عرض',
  to: 'إلى',
  from_date: 'من تاريخ',
  to_date: 'إلى تاريخ',
  of: 'من',
  entries: 'إدخالات',
  previous: 'السابق',
  next: 'التالي',
  english: 'الإنجليزية',
  arabic: 'العربية',
  change_password: 'تغيير كلمة المرور',
  new_password: 'كلمة المرور الجديدة',
  confirm_password: 'تأكيد كلمة المرور',
  changing: 'جاري التغيير...',
  enter_new_password_below: 'أدخل كلمة المرور الجديدة أدناه',
  enter_new_password: 'أدخل كلمة المرور الجديدة',
  confirm_new_password: 'تأكيد كلمة المرور الجديدة',
  new_password_required: 'كلمة المرور الجديدة مطلوبة',
  confirm_password_required: 'يرجى تأكيد كلمة المرور',
  password_min_length: 'يجب أن تكون كلمة المرور 6 أحرف على الأقل',
  passwords_do_not_match: 'كلمات المرور غير متطابقة',
  email_required: 'البريد الإلكتروني مطلوب',
  invalid_email: 'يرجى إدخال عنوان بريد إلكتروني صالح',
  password_changed: 'تم تغيير كلمة المرور بنجاح',
  password_change_failed: 'فشل تغيير كلمة المرور. يرجى المحاولة مرة أخرى.',
  unable_to_retrieve_email: 'تعذر استرداد بريد المستخدم الإلكتروني. يرجى الاتصال بالدعم.',
  generic_error: 'حدث خطأ. يرجى المحاولة مرة أخرى.',
  show_password: 'إظهار كلمة المرور',
  hide_password: 'إخفاء كلمة المرور',
  ticket_generate: 'إنشاء تذكرة',
  order: 'الطلب',
  select_an_order: 'اختر طلباً',
  loading_orders: 'جاري تحميل الطلبات...',
  select_service_provider: 'اختر مزود الخدمة',
  select_both_service_and_provider: 'اختر الخدمة ومزود الخدمة',
  no_issues_available: 'لا توجد مشاكل متاحة',
  select_issue: 'اختر المشكلة',
  loading_issues: 'جاري تحميل المشاكل...',
  reason: 'السبب',
  enter_reason: 'أدخل السبب',
  adding: 'جاري الإضافة...',
  add_ticket: 'إضافة تذكرة',
  order_id_label: 'رقم الطلب',
  service_label: 'الخدمة',
  service_provider_label: 'مزود الخدمة',
  ticket_details: 'تفاصيل التذكرة',
  basic_information: 'المعلومات الأساسية',
  ticket_number: 'رقم التذكرة',
  created_at: 'تاريخ الإنشاء',
  service_information: 'معلومات الخدمة',
  issue_information: 'معلومات المشكلة',
  customer_information: 'معلومات العميل',
  customer_ticket_counts: 'عدد تذاكر العميل',
  email: 'البريد الإلكتروني',
  phone: 'الهاتف',
  loading_ticket_details: 'جاري تحميل تفاصيل التذكرة...',
  orders_loaded_successfully: 'تم تحميل الطلبات بنجاح',
  complain_created_successfully: 'تم إنشاء فئة المشكلة بنجاح!',
  ticket_created_successfully: 'تم إنشاء التذكرة بنجاح!',
  edit_functionality_coming_soon: 'وظيفة التعديل قريباً',
  user_id_required_to_fetch_orders: 'معرف المستخدم مطلوب لجلب الطلبات',
  please_select_a_service: 'يرجى اختيار خدمة',
  please_select_a_provider: 'يرجى اختيار مزود',
  please_select_an_order: 'يرجى اختيار طلب',
  please_select_an_issue: 'يرجى اختيار مشكلة',
  please_enter_issue_in_english: 'يرجى إدخال المشكلة باللغة الإنجليزية',
  provider_deleted_successfully: 'تم حذف المزود بنجاح',
  provider_added_successfully: 'تم إضافة المزود بنجاح',
  provider_updated_successfully: 'تم تحديث المزود بنجاح',
  provider_status_updated_successfully: 'تم تحديث حالة المزود بنجاح',
  service_deleted_successfully: 'تم حذف الخدمة بنجاح',
  service_added_successfully: 'تم إضافة الخدمة بنجاح',
  service_updated_successfully: 'تم تحديث الخدمة بنجاح',
  service_status_updated_successfully: 'تم تحديث حالة الخدمة بنجاح',
  category_deleted_successfully: 'تم حذف الفئة بنجاح',
  category_added_successfully: 'تم إضافة الفئة بنجاح',
  category_updated_successfully: 'تم تحديث الفئة بنجاح',
  category_status_updated_successfully: 'تم تحديث حالة الفئة بنجاح',
  department_deleted_successfully: 'تم حذف القسم بنجاح',
  department_added_successfully: 'تم إضافة القسم بنجاح',
  department_updated_successfully: 'تم تحديث القسم بنجاح',
  department_status_updated_successfully: 'تم تحديث حالة القسم بنجاح',
  complain_deleted_successfully: 'تم حذف فئة المشكلة بنجاح',
  complain_added_successfully: 'تم إضافة فئة المشكلة بنجاح',
  complain_updated_successfully: 'تم تحديث فئة المشكلة بنجاح',
  complain_status_updated_successfully: 'تم تحديث حالة فئة المشكلة بنجاح',
  fetch_failed: 'فشل جلب البيانات. يرجى المحاولة مرة أخرى.',
  unauthorized: 'يرجى تسجيل الدخول للمتابعة',
  access_denied: 'تم رفض الوصول',
  access_denied_message: 'ليس لديك إذن للوصول إلى هذا القسم.',
  go_to_dashboard: 'الذهاب إلى لوحة التحكم',
  update_failed: 'فشل التحديث. يرجى المحاولة مرة أخرى.',
  delete_failed: 'فشل الحذف. يرجى المحاولة مرة أخرى.',
  save_failed: 'فشل الحفظ. يرجى المحاولة مرة أخرى.',
  an_error_occurred: 'حدث خطأ. يرجى المحاولة مرة أخرى.',
  user_id_not_found: 'لم يتم العثور على معرف المستخدم في الاستجابة',
  otp_resent_successfully: 'تم إعادة إرسال رمز التحقق بنجاح!',
  logged_out_successfully: 'تم تسجيل الخروج بنجاح',
  login_successful: 'تم تسجيل الدخول بنجاح!',
  logout: 'تسجيل الخروج',
  welcome_back: 'مرحباً بعودتك',
  sign_in_to_continue: 'قم بتسجيل الدخول للمتابعة إلى حسابك',
  email_address: 'عنوان البريد الإلكتروني',
  password: 'كلمة المرور',
  remember_me: 'تذكرني',
  forgot_password: 'نسيت كلمة المرور؟',
  sign_in: 'تسجيل الدخول',
  sending_otp: 'جاري إرسال رمز التحقق...',
  added_successfully: 'تمت الإضافة بنجاح',
  updated_successfully: 'تم التحديث بنجاح',
  deleted_successfully: 'تم الحذف بنجاح',
  chat_dashboard: 'لوحة تحكم الدردشة',
  chat: 'الدردشة',
  conversations: 'المحادثات',
  filters: 'الفلاتر',
  enter_ticket_id: 'أدخل رقم التذكرة',
  all_senders: 'جميع المرسلين',
  all_status: 'جميع الحالات',
  search_messages: 'البحث في الرسائل...',
  reset: 'إعادة تعيين',
  apply_filters: 'تطبيق الفلاتر',
  no_conversations_found: 'لم يتم العثور على محادثات',
  no_messages: 'لا توجد رسائل',
  close: 'إغلاق',
  loading_messages: 'جاري تحميل الرسائل...',
  no_messages_yet: 'لا توجد رسائل بعد',
  type_a_message: 'اكتب رسالة...',
  select_a_conversation: 'اختر محادثة',
  select_conversation_to_view_messages: 'اختر محادثة لعرض الرسائل',
  please_enter_a_message: 'يرجى إدخال رسالة',
  message_sent_successfully: 'تم إرسال الرسالة بنجاح',
  edit_message: 'تعديل الرسالة',
  delete_message: 'حذف الرسالة',
  message_edited: 'معدّلة',
  message_deleted: 'تم حذف هذه الرسالة',
  confirm_delete_message: 'لا يمكن التراجع عن هذا الإجراء. لن يرى العميل هذه الرسالة بعد الآن.',
  message_updated_successfully: 'تم تحديث الرسالة بنجاح',
  message_deleted_successfully: 'تم حذف الرسالة بنجاح',
  just_now: 'الآن',
  m_ago: 'د مضت',
  h_ago: 'س مضت',
  d_ago: 'ي مضت',
  sender: 'المرسل',
  read_status: 'حالة القراءة',
  ticket_id: 'رقم التذكرة',
  messages: 'الرسائل',
  send: 'إرسال',
  start_conversation_below: 'ابدأ محادثة أدناه',
  no_orders_found_for_service: 'لم يتم العثور على طلبات لهذه الخدمة',
  external_ticket_id: 'رقم التذكرة الخارجية',
  enter_external_ticket_id: 'أدخل رقم التذكرة الخارجية',
  update_ticket_status: 'تحديث حالة التذكرة',
  new_status: 'الحالة الجديدة',
  select_status: 'اختر الحالة',
  enter_reason_for_status_change: 'أدخل السبب لتحديث الحالة',
  reason_for_status_change: 'السبب لتحديث الحالة',
  please_select_status_and_enter_reason: 'يرجى اختيار الحالة وإدخال السبب',
  failed_to_upload_attachments: 'فشل تحميل المرفقات',
  uploaded_image: 'الصورة المرفقة',
  attachments: 'المرفقات',
  order_id: 'رقم الطلب',
  image_size_too_large: 'حجم الصورة كبير جدا',
  please_select_valid_image: 'يرجى اختيار صورة صالحة',
  image_uploaded_successfully: 'تم رفع الصورة بنجاح',
  failed_to_get_image_url: 'فشل الحصول على URL الصورة',
  please_select_image: 'يرجى اختيار صورة',
  no_orders_available: 'لا توجد طلبات متاحة',
  ticket_status_updated_successfully: 'تم تحديث حالة التذكرة بنجاح',
  ticket_report: 'تقرير التذاكر',
  updated_at: 'تاريخ التحديث',
  estimating_time: 'وقت التقدير',
  total_tickets: 'إجمالي التذاكر',
  detailed_ticket_analysis: 'تحليل تفصيلي للتذاكر',
  customer_name: 'اسم العميل',
  closed_at: 'تاريخ الإغلاق',
  user_id: 'معرف المستخدم',
  customer_email: 'البريد الإلكتروني للعميل',
  customer_phone: 'رقم هاتف العميل',
  issue: 'القضية',
  issue_reason: 'سبب القضية',
  message: 'الرسالة',
  please_select_status: 'يرجى اختيار الحالة',
  customer_info: 'معلومات العميل',
  ticket_resolving_time: 'وقت حل التذكرة',
  compensation_amount: 'مبلغ التعويض',
  compensation_status: 'حالة التعويض',
  compensation_date: 'تاريخ التعويض',
  compensation_information: 'معلومات التعويض',
  notes: 'ملاحظات',
  save_notes: 'حفظ الملاحظات',
  add_your_notes_here: 'أضف ملاحظاتك هنا...',
  notes_updated_successfully: 'تم تحديث الملاحظات بنجاح',
  failed_to_update_notes: 'فشل تحديث الملاحظات',
  notes_history: 'سجل الملاحظات',
  added_by: 'أضيف بواسطة',
  no_notes_available: 'لا توجد ملاحظات متاحة',
  add_note: 'إضافة ملاحظة',
  d: 'يوم',
  h: 'ساعة',
  m: 'دقيقة',
  in_progress_tickets: 'تذاكر قيد التنفيذ',
  role_list: 'قائمة الأدوار',
  assign_role_permission: 'تعيين دور',
  first_admin_response: 'الرد الأول من المسؤول',
  not_replied_yet: 'لم يتم الرد بعد',
  permission_catalog: 'سجل الصلاحيات',
  permission: 'الصلاحيات',
  roles_and_permissions: 'الأدوار',
  description: 'الوصف',
  permission_key: 'مفتاح الصلاحية',
  module: 'الوحدة',
  user_id: 'معرف المستخدم',
  user: 'المستخدم',
  permissions: 'الصلاحيات',
  providers: 'المزودين',
  access_denied: 'تم رفض الوصول',
  access_denied_message: 'ليس لديك إذن للوصول إلى هذا القسم.',
  user_permission_management: 'إدارة صلاحيات المستخدم',
  user_name: 'اسم المستخدم',
  user_email: 'البريد الإلكتروني للمستخدم',
  module_name: 'اسم الوحدة',
  activity_type: 'نوع النشاط',
  record_id: 'معرف السجل',
  old_data: 'البيانات القديمة',
  new_data: 'البيانات الجديدة',
  role_name: 'اسم الدور',
  assign_role: 'تعيين دور',
  add_assign_role: 'إضافة تعيين دور',
  update_role: 'تحديث الدور',
  role_management: 'إدارة الأدوار',
  role_management: 'إدارة الأدوار',
  role: 'الدور',
  ticket_no: 'رقم التذكرة',
  created_date_time: 'تاريخ ووقت الإنشاء',
  closed_resolved_date_time: 'تاريخ ووقت الإغلاق / الحل',
  ticket_status: 'حالة التذكرة',
  service_vertical: 'الخدمة',
  issue_type_complaint_reason: 'نوع المشكلة / سبب الشكوى',
  customer_id_mobile: 'معرف العميل / الجوال',
  agent_name: 'اسم الوكيل',
  aging_duration: 'مدة التقادم',
  aging_category: 'فئة التقادم',
  ticket_handled_by: 'يتم التعامل مع هذه التذكرة حاليًا بواسطة:',
  unassigned: 'غير معيّن',
  latest_note_comment: 'آخر ملاحظة / تعليق',
  resolution_reason_closing_note: 'سبب الحل / ملاحظة الإغلاق',
  channel: 'القناة',
  customer_info: 'معلومات العميل',
  customer_management: 'إدارة العملاء',
  browse_and_manage_customers: 'تصفح وإدارة جميع العملاء المسجلين',
  phone: 'الهاتف',
  email: 'البريد الإلكتروني',
  Select_user: 'اختر المستخدم',
  Select_role: 'اختر الدور',
  Select_one_or_more_providers: 'اختر مزودًا واحدًا أو أكثر',
  add_assign_role: 'إضافة تعيين دور',
  role_unassigned_successfully: 'تم إلغاء تعيين الدور بنجاح',
  role_assigned_successfully: 'تم تعيين الدور بنجاح',
  assignment_updated_successfully: 'تم تحديث الدور بنجاح',
  status_updated_successfully: 'تم تحديث الحالة بنجاح',
  role_status_updated_successfully: 'تم تحديث حالة الدور بنجاح',
  edit_ticket_details: 'تعديل تفاصيل التذكرة',
  ticket_updated_successfully: 'تم تحديث التذكرة بنجاح',
  failed_to_update_ticket: 'فشل في تحديث التذكرة',
};
